import Swal from "sweetalert2";
import { formatDate } from "./formatDate";

// Update CAR record in Zoho Creator
export const updateCARRecord = async (recordId, updateData) => {
  console.log("updateCARRecord called with:", { recordId, updateData });

  if (!recordId) {
    console.error("No recordId provided to updateCARRecord");
    Swal.fire({
      title: "Update Failed",
      text: "No record ID provided for update.",
      icon: "error",
      confirmButtonText: "OK",
    });
    return false;
  }

  const conn_name = "crmwidgetconnection";
  // Update the API URL for CAR records
  const apiUrl = `https://www.zohoapis.com/creator/v2.1/data/sst1source/source-erp/report/CAR_PAR1/${recordId}`;

  // Map updateData to Zoho Creator field names for CAR
  const formattedData = {};

  // Example field mappings (adjust as needed for your Zoho Creator CAR fields)
  if (updateData.name !== undefined) formattedData.CAR_Name = updateData.name;
  if (updateData.date !== undefined) formattedData.CAR_Date = updateData.date;
  if (updateData.Reported_By !== undefined)
    formattedData.CAR_Reported_By = updateData.Reported_By;
  if (updateData.Describe_the_issue_or_problem_in_detail !== undefined)
    formattedData.Describe_the_issue_or_problem_in_detail =
      updateData.Describe_the_issue_or_problem_in_detail;
  if (updateData.assignedTo !== undefined)
    formattedData.CAR_PAR_Assigned_to = updateData.assignedTo;
  if (updateData.AssignedDate !== undefined)
    formattedData.Date_Assigned = updateData.AssignedDate;
  if (updateData.respondBy !== undefined)
    formattedData.Respond_by = updateData.respondBy;
  if (updateData.containment !== undefined)
    formattedData.Containment_Immediate_Corrections = updateData.containment;
  if (updateData.rootCause !== undefined)
    formattedData.Root_cause_of_Problem = updateData.rootCause;
  if (updateData.actionPlan !== undefined)
    formattedData.Action_Plan = updateData.actionPlan;
  if (updateData.actionCompleted !== undefined)
    formattedData.Date_Action_Completed = updateData.actionCompleted;
  if (updateData.Assignee_Name !== undefined)
    formattedData.Assignee_Name = updateData.Assignee_Name;
  if (updateData.verifiedDate !== undefined)
    formattedData.Verified_Date = updateData.verifiedDate;
  if (updateData.notes !== undefined) formattedData.Notes = updateData.notes;

  // Type checkboxes
  formattedData.Corrective_action =
    updateData.type === "corrective" ? "true" : "false";
  formattedData.Preventive_action_potential_issue =
    updateData.type === "preventive" ? "true" : "false";
  formattedData.Opportunity_for_Improvement_suggestion =
    updateData.type === "improvement" ? "true" : "false";

  // Source checkboxes
  formattedData.Employee_Source_Creator =
    updateData.Source === "Employeecheckbox" ? "true" : "false";
  formattedData.CustomerSourceCreator =
    updateData.Source === "CustomerSource" ? "true" : "false";
  formattedData.ExternalAuditFindingCreator =
    updateData.Source === "ExternalAuditFinding" ? "true" : "false";
  formattedData.InternalAuditFindingCreator =
    updateData.Source === "InternalAuditFinding" ? "true" : "false";
  formattedData.SupplierSourceCreator =
    updateData.Source === "SupplierSource" ? "true" : "false";
  formattedData.ManagementReviewCreator =
    updateData.Source === "ManagementReview" ? "true" : "false";
  formattedData.OtherSourceCreator =
    updateData.Source === "OtherSource" ? "true" : "false";

  // Process checkboxes
  formattedData.EstimatingSchedulingArtCreator =
    updateData.Process === "EstimatingSchedulingArt" ? "true" : "false";
  formattedData.PrintingFinishingCreator =
    updateData.Process === "PrintingFinishing" ? "true" : "false";
  formattedData.PurchasingReceivingShippingCreator =
    updateData.Process === "PurchasingReceivingShipping" ? "true" : "false";
  formattedData.InstallationSourceCreator =
    updateData.Process === "InstallationSource" ? "true" : "false";
  formattedData.OtherprocessCreator =
    updateData.Process === "Otherprocess" ? "true" : "false";

  // Priority checkboxes
  formattedData.LowPriorityCreator =
    updateData.Priority === "LowPriority" ? "true" : "false";
  formattedData.MediumPriorityCreator =
    updateData.Priority === "MediumPriority" ? "true" : "false";
  formattedData.HighPriorityCreator =
    updateData.Priority === "HighPriority" ? "true" : "false";
  formattedData.UrgentCriticalCreator =
    updateData.Priority === "UrgentCritical" ? "true" : "false";

  // Result checkboxes
  formattedData.PassCreator =
    updateData.Result === "PassResult" ? "true" : "false";
  formattedData.FailCreator =
    updateData.Result === "FailResult" ? "true" : "false";

  // Machine, Employee, SO, Account fields (IDs)
  if (updateData.MachineID) formattedData.Machine = updateData.MachineID;
  if (updateData.qualityOwner) formattedData.Employee = updateData.qualityOwner;
  if (updateData.qualityOwner1)
    formattedData.Verified_by = updateData.qualityOwner1;
  if (updateData.accountId)
    formattedData.CRM_Account_Name_CAR = updateData.accountId;
  if (updateData.soIdPalyoad) formattedData.Job_name = updateData.soIdPalyoad;

  //
  // Enhance the logging for Status_Kanban specifically to track this field
  if (updateData.Status_Kanban) {
    console.log("Setting Status_Kanban field to:", updateData.Status_Kanban);
    formattedData.Status_Kanban = updateData.Status_Kanban;
  }

  //below code is for Date fields
  if (updateData.date)
    formattedData.CAR_Date = formatDate(new Date(updateData.date));
  if (updateData.AssignedDate)
    formattedData.Date_Assigned = formatDate(new Date(updateData.AssignedDate));
  if (updateData.respondBy)
    formattedData.Respond_by = formatDate(new Date(updateData.respondBy));
  if (updateData.actionCompleted)
    formattedData.Date_Action_Completed = formatDate(
      new Date(updateData.actionCompleted)
    );
  if (updateData.verifiedDate)
    formattedData.Verified_Date = formatDate(new Date(updateData.verifiedDate));

  // ...add any additional field mappings as needed...

  // Log the formatted data being sent to the API
  console.log("Sending formatted data to API:", formattedData);

  const payload = {
    parameters: {
      data: formattedData,
    },
    method: "PATCH",
    url: apiUrl,
    param_type: 2,
  };

  try {
    console.log("Sending request to ZOHO.CRM.CONNECTION.invoke");
    const response = await ZOHO.CRM.CONNECTION.invoke(conn_name, payload);
    console.log("Update Response:", response);

    if (response && response.code === "SUCCESS") {
      return true;
    } else {
      const errorMsg = response?.message || "Unknown error occurred.";
      console.error("API error response:", errorMsg);

      Swal.fire({
        title: "Update Failed",
        text: errorMsg,
        icon: "error",
        confirmButtonText: "OK",
      });
      return false;
    }
  } catch (err) {
    console.error("Update error:", err);

    Swal.fire({
      title: "Error",
      text: `An error occurred while updating the record: ${
        err.message || "Unknown error"
      }`,
      icon: "error",
      confirmButtonText: "OK",
    });
    return false;
  }
};
